import React, { useState, useEffect } from "react";
import moment from "moment";
import { db } from '../firebase';
import { collection, addDoc, Timestamp, doc, updateDoc, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const NamaazCalculator = () => {
  const [dob, setDob] = useState("");
  const [yearsOfNamaazRead, setYearsOfNamaazRead] = useState(0);
  
  const [isDisable, setDisable] = useState(true);

  const [textMessage, setTextMessage] = useState("")

  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userInfo);

  const [data, setData] = useState({
    fajr : 0,
    zohar: 0,
    asr: 0,
    magrib: 0,
    isha: 0,
    witr: 0
});


useEffect(()=>{

  if(user==null){
    navigate("/login")
  }else{
    initializeRecord()
  }
    

  },[])

  useEffect(()=>{

    if(dob==""){
      return
    }

    let _dobStr = moment(dob).format('DD MMM yyyy')
    let message = <>Your date of birth is: {_dobStr}<br></br> On average, Namaaz becomes obligatory from the age of 12.<br></br>You mentioned that you have been offering Namaaz for approximately {yearsOfNamaazRead} years.</>
    
    setTextMessage(message)

  },[dob, yearsOfNamaazRead])



  const initializeRecord = async () => {
    const querySnapshot = await getDocs(collection(db, 'qazaa_namaaz',user.user.uid+'/db'));
      const dataArr = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
      }));

      let _data = dataArr[0]

      if(_data!=null){
        setData(_data)
        
      }
      setDisable(false)
  }

  const calculateMissingDays = async (e) => {
    e.preventDefault();
    setDisable(true)
    if (!dob || yearsOfNamaazRead < 0) {
      alert("Please enter valid inputs!");
      return;
    }

    const birthDate = new Date(dob);

    const namazQazaaStartsFrom = moment(birthDate).add(yearsOfNamaazRead+12,'year').toDate()

    console.info(namazQazaaStartsFrom)

    
    const daysDifference = moment().diff(moment(namazQazaaStartsFrom),'days')

    try{

      var _data = {}

      _data.fajr = daysDifference
      _data.zohar = daysDifference
      _data.asr = daysDifference
      _data.magrib = daysDifference
      _data.isha = daysDifference
      _data.witr = daysDifference

      if(data==null || data.id == null){

        const docRef = await addDoc(collection(db, 'qazaa_namaaz',user.user.uid+'/db'), {
          ..._data,
          createdAt: Timestamp.now(),
          updatedAt: Timestamp.now()
        });

        console.log("Document written with ID: ", docRef.id);

      }else{

        const documentRef = doc(db, 'qazaa_namaaz',user.user.uid+'/db/'+data.id);
        try {
          await updateDoc(documentRef, {
            ..._data,
            updatedAt: Timestamp.now()
          });
          console.log('Document updated successfully!');
        } catch (error) {
          console.error('Error updating document:', error);
        }

      }

      setDisable(false)
      
      navigate('/');
    } catch (e) {
      console.error("Error adding document: ", e);
    }

    
  };

  return (
    <div style={{ maxWidth: "400px", margin: "auto", padding: "20px" }}>
      <h2>Namaaz Days Calculator</h2>
      <div>
        <label>Date of Birth:</label><br />
        <input
          type="date"
          value={dob}
          onChange={(e) => setDob(e.target.value)}
          style={{ marginBottom: "10px", width: "100%" }}
        />
      </div>

      <div>
        <label>Years you regularly read Namaaz:</label><br />
        <input
          type="number"
          value={yearsOfNamaazRead}
          onChange={(e) => setYearsOfNamaazRead(parseInt(e.target.value))}
          style={{ marginBottom: "10px", width: "100%" }}
          min="0"
        />
      </div>

      <p>{textMessage}</p>

      <button disabled={isDisable} onClick={calculateMissingDays} style={{ marginTop: "10px" }}>
        Calculate
      </button>

    </div>
  );
};

export default NamaazCalculator;